import { useState } from "react";

// The theme's wash tones; a person always gets the same one (hashed from seed).
const TONES = [
  "bg-accent-wash text-accent-text",
  "bg-warning-wash text-warning-text",
  "bg-danger-wash text-danger-text",
  "bg-raised text-ink",
];

const SIZES = {
  sm: "h-8 w-8 text-xs",
  lg: "h-14 w-14 text-lg",
};

const toneFor = (seed = "") => {
  let hash = 0;
  for (const char of String(seed)) hash = (hash * 31 + char.codePointAt(0)) | 0;
  return TONES[Math.abs(hash) % TONES.length];
};

/**
 * A customer's own photo (from their app account), or a circle with the first
 * letter of their first name — the same fallback the customer app draws.
 * Decorative: the name is always shown beside it.
 */
export default function CustomerAvatar({ name = "", photoUrl, seed, size = "sm" }) {
  const [broken, setBroken] = useState(false);
  const letter = (name.trim().split(/\s+/)[0] || "").charAt(0).toUpperCase() || "·";
  const box = SIZES[size] ?? SIZES.sm;

  if (photoUrl && !broken) {
    return (
      <img
        src={photoUrl}
        alt=""
        loading="lazy"
        onError={() => setBroken(true)}
        className={`${box} shrink-0 rounded-full object-cover`}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className={`${box} ${toneFor(seed ?? name)} grid shrink-0 place-items-center rounded-full font-bold`}
    >
      {letter}
    </span>
  );
}
